import React, { useEffect, useState } from "react";
import {
  CancelButton,
  SubmitButton,
  UpdateButton,
} from "../../../../../components/mui/Buttons/Buttons";
import { Form, FormikProvider, useFormik } from "formik";
import { Box, Stack, TextField } from "@mui/material";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import GlobalSelectField from "../../../../../components/mui/GlobalSelectField";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import {
  getAllBrands,
  updateBrand,
} from "../../../../../redux/features/assetManagementSlice";
import { EditButton } from "../../../../../components/mui/Buttons/Buttons";
import { updateCertificate } from "../../../../../redux/features/CRDslice";

const CourseCertificate = ({ rowData, CourseEnrollmentId, crm ,dispatchParams,apiCall}) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading } = useSelector((state) => state.crd);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      certificate: "",
      course_enrollment_id: CourseEnrollmentId,
    },
    onSubmit: (values) => {
      dispatch(updateCertificate(values)).then((res) => {
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
          setOpen(false);
          if(apiCall && dispatchParams){
            dispatch(apiCall(dispatchParams));
          }
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
          // setOpen(false);
        }
      });
    },
  });

  const certficateStatus = [
    { id: 0, name: "Not Issued" },
    { id: 1, name: "Issued" },
    { id: 2, name: "Not Applicable" },
  ];
  return (
    <GlobalDialog
      title={"Course Certificate"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"sm"}
      closeButton={true}
      popupButton={
        <EditButton size="small" action={() => setOpen(true)} disabled={!crm}>
          Edit
        </EditButton>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={"column"} spacing={2}>
                  <GlobalSelectField
                    options={{
                      formik,
                      name: "certificate",
                      label: "Course Certificate",
                      data: certficateStatus,
                      keys: {
                        id: "id",
                        value: "name",
                      },
                    }}
                  />
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <CancelButton size="small" action={() => setOpen(false)}>
                      Cancel
                    </CancelButton>
                    <SubmitButton disabled={loading} size="small" type="submit">
                      {loading ? "Please wait..." : "Save"}
                    </SubmitButton>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default CourseCertificate;
